module.exports = __webpack_public_path__ + "img/IMN.ff8c7271.svg";